/**
 * Admin Outlook Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  MigrateOutlookWebhookBodySchema,
  MigrateOutlookWebhookResponseSchema,
  OutlookDeploymentStatusSchema,
  OutlookMigrationStatusResponseSchema
} from "./schemas/outlook-migration.schemas";

export const ZAdminOutlookMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/outlook/status",
    Response: ApiSuccessSchema(OutlookMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/outlook/migrate",
    Body: MigrateOutlookWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateOutlookWebhookResponseSchema)
  }
} as const;

export type TApiAdminOutlookMigration = InferSchemas<typeof ZAdminOutlookMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type OutlookDeploymentStatus = z.infer<typeof OutlookDeploymentStatusSchema>;
export type OutlookMigrationStatusResponse = z.infer<typeof OutlookMigrationStatusResponseSchema>;
